var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5438",
    "data-name": "Group 5438",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1978",
    "data-name": "Rectangle 1978",
    width: 50,
    height: 50,
    rx: 25,
    fill: "#3160d4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_184_",
    transform: "translate(13 15.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67645",
    "data-name": "Path 67645",
    d: "M24.477,6.3a3.142,3.142,0,0,0-2.21-2.225c-1.949-.525-9.767-.525-9.767-.525s-7.818,0-9.768.525A3.141,3.141,0,0,0,.523,6.3,32.921,32.921,0,0,0,0,12.352a32.921,32.921,0,0,0,.523,6.056,3.142,3.142,0,0,0,2.21,2.225c1.949.525,9.767.525,9.767.525s7.818,0,9.768-.525a3.144,3.144,0,0,0,2.21-2.225A32.985,32.985,0,0,0,25,12.352,32.921,32.921,0,0,0,24.477,6.3ZM9.944,16.07V8.635l6.533,3.718Z",
    transform: "translate(0 -3.546)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f360653ffda9fc36333ef4533c76ad21.svg";
export { ForwardRef as ReactComponent };